import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Masthead() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <header className="relative z-10" data-testid="masthead">
      <div className="max-w-6xl mx-auto px-6 pt-10 pb-6">
        <div className="flex items-center justify-between text-xs font-mono-plex uppercase tracking-widest">
          <span data-testid="masthead-date">{today}</span>
          <span>Vol. I · Reno, Nevada · Est. 1893</span>
        </div>
        <div className="rule-thin my-4" />
        <div className="text-center">
          <Link to="/" className="inline-block" data-testid="masthead-title-link">
            <h1 className="font-serif-display font-black text-6xl sm:text-7xl md:text-8xl leading-none tracking-tight" style={{ color: "var(--ink-navy)" }}>
              Brush Up
            </h1>
          </Link>
          <div className="rule-thin mt-4 mb-2" />
          <p className="font-mono-plex text-xs sm:text-sm uppercase tracking-[0.35em]" style={{ color: "var(--muted)" }}>
            A Word Puzzle · Created by The Nevada Sagebrush
          </p>
          <div className="rule-thin mt-2" />
        </div>
        {!isAdmin && (
          <div className="flex justify-end mt-3">
            <Link
              to="/admin"
              className="font-mono-plex text-[10px] uppercase tracking-widest underline underline-offset-4 hover:text-black"
              style={{ color: "var(--muted)" }}
              data-testid="masthead-admin-link"
            >
              Editor's Desk →
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
